export default __webpack_public_path__ + "static/media/Icon-open-account-logout-dark.717afca4.svg";